module.exports = __webpack_public_path__ + "img/icon-ai-green.448b4371.svg";